import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import './style.scss';

export const Loading = () => (
  <Suspense fallback={<div className="loading-container">Loading...</div>}>
    <Outlet />
  </Suspense>
);
